module.exports = __webpack_public_path__ + "static/media/dashboard.80067f94.svg";